"use client";
import Image, { StaticImageData } from "next/image";

interface KrooloAiLink {
  label: string;
  url: string;
  icon: StaticImageData;
  image?: StaticImageData;
  subtext?: string;
}

interface AiToolsLink {
  label: string;
  url: string;
  icon: StaticImageData;
  subtext?: string;
}

interface AllKrooloAiNavProps {
  krooloAiLinks: KrooloAiLink[];
  aiToolsLinks: AiToolsLink[];
}

const AllKrooloAiNav: React.FC<AllKrooloAiNavProps> = ({
  krooloAiLinks,
  aiToolsLinks,
}) => {
  return (
    <div className="mb-16 mt-1 h-[calc(100dvh-246px)] overflow-y-auto border-b-[0.25px] border-[#535252] pb-4 text-white">
      {krooloAiLinks.length > 0 && (
        <div className="mb-4">
          <h3 className="mb-2 text-base font-semibold text-[#202020]">AI</h3>
          <div className="grid grid-cols-1 gap-3 md:grid-cols-3 lg:grid-cols-4">
            {krooloAiLinks.map((link, linkIdx) => (
              <a
                href={link.url}
                rel="noreferrer"
                key={linkIdx}
                className="mb-2 flex items-center gap-2 p-1 text-sm"
              >
                <Image
                  src={link.icon || ""}
                  alt={link.label || ""}
                  width={16}
                  height={16}
                />
                <p className="text-sm font-normal text-[#202020]">
                  {link.label}
                </p>
              </a>
            ))}
          </div>
        </div>
      )}
      {aiToolsLinks.length > 0 && (
        <div className="mb-4">
          <h3 className="mb-2 text-base font-semibold text-[#202020]">
            AI Tools
          </h3>
          <div className="grid grid-cols-1 gap-3 md:grid-cols-3 lg:grid-cols-4">
            {aiToolsLinks.map((link, linkIdx) => (
              <a
                href={link.url}
                rel="noreferrer"
                key={linkIdx}
                className="mb-2 flex items-center gap-2 p-1 text-sm"
              >
                <Image
                  src={link.icon || ""}
                  alt={link.label || ""}
                  width={16}
                  height={16}
                />
                <p className="text-sm font-normal text-[#202020]">
                  {link.label}
                </p>
              </a>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default AllKrooloAiNav;
